import buttonLabels from '../buttonLabels';
import { eventCancelFlowCompleted } from './eventsHandlers';
import CANCEL_FLOW_EXPERIENCE from './experiences';

const SEGMENT_EVENT = {
  success: 'Success',
  failure: 'Failure',
};
const subscriptionLabel = {
  fffvip: 'Seasonal Subscription',
  fffvipa: 'Annual Subscription',
  ffftrial: 'SGTF Trial',
};

const mapCancelType = (planCode: string): string =>
  subscriptionLabel[planCode as keyof typeof subscriptionLabel];

const fireCancelFlowCompleted = (status: string, planCode: string): Promise<void> =>
  eventCancelFlowCompleted({
    cta_name: buttonLabels.CANCEL_BOX,
    experience: CANCEL_FLOW_EXPERIENCE,
    status,
    cancel_type: mapCancelType(planCode),
  });

export { fireCancelFlowCompleted, SEGMENT_EVENT };
